import { getTwoLetterTag } from "CMS/utils";
import { PhosphorPencilButton, PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import LabelledDivRow from "components/LabelledDivRow";
import Tag from "components/Tag/Tag";
import moment from "moment";
import React from "react";
import { formatShortDate } from "utilities";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  article: server.dto.Article;
  translation: server.dto.ArticleTranslation;

  onEdit: (translation: server.dto.ArticleTranslation) => void;
  onDelete: (translation: server.dto.ArticleTranslation) => void;
  onImageUpload: (file: File) => void;
}

const ReadonlyArticle = ({ article, translation, onEdit, onDelete, onImageUpload }: Props) => {
  const fileRef = React.useRef<HTMLInputElement>();

  const getRelatedArticleTitle = (translations: server.dto.ArticleTranslation[]): string => {
    const relatedArticleTranslation = translations.find(t => t.language === translation.language);
    return relatedArticleTranslation?.title || translations[0].title;
  }

  const createMarkup = () => {
    return {
      __html: "<h1>" + translation.title + "</h1>" + (translation.content ?? "")
    }
  }

  const onFileChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const file = e.target.files[0];
    onImageUpload(file);
  }

  return <>
    <div className="gray-100 padding-big flex margin-bottom-huge">
      {article.section === "blog" && <div className="margin-right" onClick={() => fileRef.current?.click()}>
        {article.listImage
          ? <img src={article.listImage} className="listimage" />
          : <div className="nolistimage flex align-center justify-center">No image</div>
        }
        <input
          type="file"
          ref={fileRef}
          style={{ display: "none" }}
          accept="image/*"
          onChange={onFileChange} />
      </div>}
      <div className="grow1">
        <div className="margin-bottom-large">
          <h2>
            {article.internalTitle}
          </h2>
        </div>

        <LabelledDivRow label={"URL"}>
          <a href={`${site.deploymentValues.promoSiteUrl}/${getTwoLetterTag(translation.language)}/${article.section}/article/${article.articleId}-${translation.slug}?includeUnpublished=true`}>
            {translation.slug || "<No slug>"}
          </a>
        </LabelledDivRow>
        <LabelledDivRow label="Status">
          {!article.isPublished && <Tag color="red" label="Unpublished" />}
          {article.isPublished && <Tag color="green" label="Published" />}
        </LabelledDivRow>

        <LabelledDivRow label="Categories">
          <div>{[...article.categories].sort((a, b) => a.englishTitle.localeCompare(b.englishTitle)).map(c => c.englishTitle).join(", ")}</div>
        </LabelledDivRow>

        <LabelledDivRow label="Publish date">
          <div>{formatShortDate(moment.utc(article.publication))}</div>
        </LabelledDivRow>

        <LabelledDivRow label="Summary">
          <div>{translation.summary || "No summary"}</div>
        </LabelledDivRow>

        <LabelledDivRow label="Relevant articles">
          <div className="flex gap">
            {article.relatedArticles.map(a => <a key={a.articleId} href={routes.article_Detail(a.articleId).absolute}>{getRelatedArticleTitle(a.translations)}</a>)}
            {article.relatedArticles.length === 0 && <div>No relevant articles</div>}
          </div>
        </LabelledDivRow>
      </div>
      <div className="flex gap-small">
        <PhosphorPencilButton
          layout="in-square"
          onClick={() => onEdit(translation)} />

        {(translation.language !== "english") && <PhosphorTrashButton
          layout="in-square"
          onClick={() => onDelete(translation)} />}
      </div>
    </div>
    <article dangerouslySetInnerHTML={createMarkup()}>

    </article>
  </>
}

export default ReadonlyArticle;